<label class="switcher">
  <ng-container *ngIf="label && labelPosition === 'before'">{{ label }}</ng-container>
  <input type="checkbox" class="switcher-input" [(ngModel)]="value" />
  <span class="switcher-inner">
    <span class="switcher-toggle"></span>
  </span>
  <ng-container *ngIf="label && labelPosition === 'after'">{{ label }}</ng-container>
</label>
